import { render } from "./VP1Pattern.vue?vue&type=template&id=59274a3e"
import script from "./VP1Pattern.vue?vue&type=script&lang=js"
export * from "./VP1Pattern.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__